import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/page/homepage/index'
import AlbumInfo from '@/page/album/info'
import DownLoad from '@/page/download/index'
import DownLoadBilibili from '@/page/downloadBilibili/index'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: Home
    },
    {
      path: '/home',
      name: 'home',
      component: Home
    },
    {
      path: '/album/info',
      name: 'AlbumInfo',
      component: AlbumInfo
    },
    {
      path: '/download',
      name: 'DownLoad',
      component: DownLoad
    },
    {
      path: '/download_bilibili',
      name: 'DownLoadBilibili',
      component: DownLoadBilibili
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js